import BaseRepository from "@/services/resources/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    record(id) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .include('person-podcasts')
                    .find(id)
            )
        );
    }

    search(keywords) {
        return this.transformer.many(
            this.try(
                this.baseSearchQuery(
                    ['podcast-modules.modules.modules'],
                    ['title', 'summary', 'podcast-modules.modules.modules.attributes']
                    , keywords
                ).get()
            )
        ).then(collection => {
            return collection.map(record => {
                return {
                    type: 'podcasts',
                    id: record.id,
                    text: record.title,
                    resource: record,
                    badgeVariant: 'gamma',
                    badgeText: 'Podcast',
                }
            })
        })
    }
}

export default Repository;
